import get from "lodash.get";
import React, { FC } from "react";
import {
	useController,
	useFormContext,
	useFormState,
	useWatch
} from "react-hook-form";

interface Props {
	stepNumber: number;
	order: number;
}

const TextareaStep: FC<Props> = ({ stepNumber, order }) => {
	const { control } = useFormContext<BannerFormState>();

	const bannerStyle = useWatch({
		control,
		name: "bannerStyle"
	});

	const fieldType = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.field`
	});

	const optional = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.optional`
	});

	const rules = {
		required:
			bannerStyle === "standard" && !optional
				? true
				: fieldType !== "buttonLink" && !optional
	};

	const { field } = useController({
		name: `steps.${stepNumber - 1}.fields.${order - 1}.givenAnswer`,
		control,
		rules
	});

	const placeholder = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.placeholder`
	});

	const maxLength = useWatch({
		control,
		name: `steps.${stepNumber - 1}.fields.${order - 1}.maxChar`
	});

	const { errors } = useFormState({ control });

	const isAnswerInvalid = Boolean(
		get(errors, `steps[${stepNumber - 1}].fields[${order - 1}]`, null)
	);

	return (
		<div className="flex flex-col w-full">
			<textarea
				id={`step-${stepNumber}`}
				placeholder={placeholder}
				className={[
					"w-full bg-white px-3 py-2 rounded-lg border text-base text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring transition-colors resize-none overflow-hidden",
					isAnswerInvalid ? "border-red-500" : "border-border"
				].join(" ")}
				aria-label={`step-${stepNumber}-order-${order}`}
				maxLength={maxLength as number}
				rows={2}
				onInput={(e) => {
					const target = e.target as HTMLTextAreaElement;
					target.style.height = "auto";
					target.style.height = `${target.scrollHeight}px`;
				}}
				{...field}
			/>
			{maxLength && (
				<span
					aria-label="character-count"
					className="text-[13px] text-zinc-600 self-end mt-1"
				>
					{field.value?.length} / {maxLength}
				</span>
			)}
		</div>
	);
};

export default TextareaStep;
